(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initialiseCard(card) {
    if (card.dataset.offerTimerInitialised === 'true') return;
    card.dataset.offerTimerInitialised = 'true';

    const countdown = card.querySelector('[data-offer-countdown]');
    if (!countdown) return;

    const endTime = card.dataset.endTime || '23:59:59';
    const endToday = card.dataset.endToday === 'true';
    let endDate = card.dataset.endDate || '';

    if (endToday) {
      const now = new Date();
      endDate = [
        now.getFullYear(),
        pad(now.getMonth() + 1),
        pad(now.getDate()),
      ].join('-');
    }

    const endAt = Date.parse(`${endDate}T${endTime}`);
    const expired = card.querySelector('[data-offer-expired]');
    const daysWrap = card.querySelector('[data-offer-days-wrap]');
    const days = card.querySelector('[data-offer-days]');
    const hours = card.querySelector('[data-offer-hours]');
    const minutes = card.querySelector('[data-offer-minutes]');
    const seconds = card.querySelector('[data-offer-seconds]');

    if (Number.isNaN(endAt)) {
      countdown.hidden = true;
      return;
    }

    let intervalId;

    function update() {
      const remaining = endAt - Date.now();

      if (remaining <= 0) {
        countdown.hidden = true;
        if (expired) expired.hidden = false;
        if (intervalId) window.clearInterval(intervalId);
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const remainingDays = Math.floor(totalSeconds / 86400);
      const remainingHours = Math.floor((totalSeconds % 86400) / 3600);
      const remainingMinutes = Math.floor((totalSeconds % 3600) / 60);
      const remainingSeconds = totalSeconds % 60;

      daysWrap.hidden = remainingDays === 0;
      days.textContent = remainingDays;
      hours.textContent = pad(remainingHours);
      minutes.textContent = pad(remainingMinutes);
      seconds.textContent = pad(remainingSeconds);
      countdown.dataset.ready = 'true';
    }

    update();
    intervalId = window.setInterval(update, 1000);
  }

  function initialiseAll(root) {
    (root || document).querySelectorAll('[data-product-offer-card]').forEach(initialiseCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll(document);
    });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });
})();
